export const DATA_TAG_KEY = 'data';
export const ATTRIBUTES_TAG_KEY = 'attr';
